<template>
	<div>康养设备</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>